export default __webpack_public_path__ + "fonts/eae42d8b7fe983c111445ef0ff6606c1.svg";